import { Injectable, ViewChild } from '@angular/core';
import { DataBagService } from '../common/data-bag.service';
import { Observable, Observer, Subject } from 'rxjs';
import { User } from '../reservation/reservation.model';
import { ITask, Kind, Status } from './task.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Injectable({
	providedIn: 'root',
})
export class TasksService {
	data;
	parameters = new Subject();
	loggedUser;
	dataSource: MatTableDataSource<ITask> = new MatTableDataSource<ITask>();

	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatSort) sort: MatSort;
	constructor(public bag: DataBagService) {}

	loadTasks(tableId: string): void {
		this.bag.get(
			`/task_note/task/?table_id__in=${tableId}${tableId ? '' : '&users=' + this.loggedUser.id}&limit=99`,
			(result, error) => {
				if (result) {
					this.data = result.results;
					this.data.sort((a) => {
						return a.created === null ? 1 : -1;
					});
				}
				this.parameters.next(this.data);
			},
		);
	}

	loadProfile(): Promise<User> {
		return new Promise((resolve, reject) => {
			this.bag.get('/profile/', (result, error) => {
				if (result) {
					this.loggedUser = result;
					resolve(result);
				} else {
					reject(JSON.stringify(error.error));
				}
			});
		});
	}

	loadTasksStatus(): Promise<Status[]> {
		return new Promise((resolve, reject) => {
			this.bag.get('/task_note/status/', (result, error) => {
				if (result) {
					resolve(result.results);
				} else {
					reject(JSON.stringify(error.error));
				}
			});
		});
	}

	loadTaskKinds(): Promise<Kind[]> {
		return new Promise((resolve, reject) => {
			this.bag.get('/task_note/kind/', (result, error) => {
				if (result) {
					resolve(result.results);
				} else {
					reject(JSON.stringify(error.error));
				}
			});
		});
	}

	loadUsers(fullName: string): Observable<User[]> {
		return new Observable((observer: Observer<User[]>) => {
			this.bag.get(`/profile/all_users/?full_name=${fullName}`, (result, error) => {
				if (error) {
					observer.error(error);
				} else {
					observer.next(result.results);
					observer.complete();
				}
			});
		});
	}
}
